/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weighing_Filter_All_StatusInputs */

const vi_weighing_filter_all_status = /** @type {(inputs: Weighing_Filter_All_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả trạng thái`)
};

/**

* @param {Weighing_Filter_All_StatusInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const weighing_filter_all_status = /** @type {((inputs?: Weighing_Filter_All_StatusInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weighing_Filter_All_StatusInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_weighing_filter_all_status(inputs)
});